import React from 'react'
import { Column, Icon, RadioButton } from '@resurs/midas-react'
import Tooltip from '../../../../../internal/Tooltip'
import { classNames } from '../../../../../util/helpers'

import styles from './styles.module.scss'

const TooltipWrapper = ({ tooltipText, children }) =>
  !tooltipText ? (
    children
  ) : (
    <div className={styles.tooltipWrapper}>
      <div className={styles.content}>{children}</div>
      <Tooltip content={tooltipText}>
        <div className={styles.tooltip}>
          <Icon name="midasInformation" />
        </div>
      </Tooltip>
    </div>
  )

const PaymentMethodOption = props => {
  const { disabled, onChange, disabledReasons, ...otherProps } = props
  const handleClick = e => {
    if (disabled) {
      e.preventDefault()
    }
    onChange()
  }

  const handleKeyDown = e => {
    if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault()
      onChange()
    }
  }

  return (
    <Column key={props.id} col4>
      <div
        id={`${props.type}${props.id}`}
        className={classNames(styles.option, props.checked && styles.selected)}
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <TooltipWrapper tooltipText={disabledReasons?.join(' ')}>
          <RadioButton {...otherProps} disabled={disabled} />
        </TooltipWrapper>
      </div>
    </Column>
  )
}

export default PaymentMethodOption
